import React from "react";
import dataSuccess from "../../data/dataSuccess";
import NavSuccess from "./NavSuccess";
import SuccessTemplateSidebar from "./SuccessTemplateSidebar";
import MaPrimeRenovBlock from "./MaPrimeRenovBlock";
import FileUploaderAuto from "./FileUploaderAuto";
// import InfoHoverBlock from './InfoHoverBlock';
class SuccessComment extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const bgMobile = `url(${dataSuccess[this.props.success].imgMobile})`;
    // console.log('comment date', this.props.date)
    return (
      <div className="flex-container">
        <SuccessTemplateSidebar
          success={this.props.success}
          lastStep={this.props.lastStep}
          codePromo={this.props.codePromo}
          handleCodePromo={this.props.handleCodePromo}
          validCodePromo={this.props.validCodePromo}
          resultCodePromo={this.props.resultCodePromo}
          isPrime={this.props.isPrime}
        >
          {this.props.success !== "borneDeRecharge" && this.props.Q2 && (
            <div className="success-item">
              <h3>Type de logement</h3>
              <h2>{this.props.Q2}</h2>
            </div>
          )}

          {this.props.surface && (
            <div className="success-item">
              <h3>Surface</h3>
              <h2>
                {" "}
                {this.props.surface} m<sup style={{ fontSize: "0.7em" }}>2</sup>{" "}
              </h2>
            </div>
          )}

          {this.props.result.data["Couleur MPR"] && (
            <MaPrimeRenovBlock
              color={this.props.result.data["Couleur MPR"]}
            ></MaPrimeRenovBlock>
          )}
          {this.props.Q22 && (
            <div className="success-item">
              <h3>Système de chauffage</h3>
              <h2>{this.props.Q22}</h2>
            </div>
          )}

          {this.props.Q12 && (
            <div className="success-item">
              <h3>
                Distance entre la borne et <br />
                le tableau électrique
              </h3>
              <h2>{this.props.Q12}</h2>
            </div>
          )}

          {this.props.Q10 && (
            <div className="success-item">
              <h3>Modèle de voiture</h3>
              <h2>{this.props.Q10}</h2>
            </div>
          )}

          {this.props.Q11 && (
            <div className="success-item">
              <h3>Puissance souhaité</h3>
              <h2>{this.props.Q11}</h2>
            </div>
          )}
        </SuccessTemplateSidebar>

        <div className="success-right-container">
          <p
            className="text-s"
            style={{
              lineHeight: "1.1em",
              marginBottom: "10px",
              fontWeight: "500",
              marginTop: "24px",
            }}
            dangerouslySetInnerHTML={{
              __html: dataSuccess[this.props.success].h3,
            }}
          ></p>

          {this.props.showFile && (
            <FileUploaderAuto
              patchName="fileImposition"
              description="Déposez votre avis imposition pour valider le montant de votre prime"
              handleFile={this.props.handleFile}
              result={this.props.result}
              firstname={this.props.contact.firstname}
              lastname={this.props.contact.lastname}
            ></FileUploaderAuto>
          )}
          <NavSuccess
            callBtn={this.props.callBtn}
            lastStep={this.props.lastStep}
            date={this.props.date}
            creneau={this.props.creneau}
            handleDate={this.props.handleDate}
            handleCreneau={this.props.handleCreneau}
          ></NavSuccess>
        </div>
        <div
          style={{
            backgroundImage: bgMobile,
          }}
          className="success-header-img only-show-mobile"
        >
          <h1>{dataSuccess[this.props.success].h1}</h1>
        </div>
      </div>
    );
  }
}

export default SuccessComment;
